import Auth from './auth.js'
import Api from './lib/api.js';


export default async function FillaAttachmentA(contractor_id, do_not_generate_pdf) {
    
    let data = await Api.GetContractorAttachmentA(contractor_id)

    let table = document.querySelector("#table tbody")
    table.innerHTML = ""

    const formatter = new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR',
    });    

    for(let i=0;i<data.yards.length;i++) {
        try {
           
            let tr = document.createElement("tr")
            tr.innerHTML = `
                <td>${data.yards[i].name}</td>
                <td>${data.yards[i].city_province}</td>
                <td>${formatter.format(data.yards[i].amount)}</td>
                <td>${data.contractor_name}</td>
            `
            
            table.append(tr)
        }
        catch (Ex) {
            console.log(Ex)
        }
    }

    document.querySelector(".total_amount").innerHTML = formatter.format(data.total_amount)
    document.querySelector(".data").innerHTML = Timestamp(new Date())
    document.querySelector(".contractor").innerHTML = data.contractor_name
        
    if (do_not_generate_pdf == true) {
        document.title = `${data.contractor_name} - Alleagato A - ${Timestamp(new Date(),true)}`
        return
    }

    var element = document.getElementById('allegato_a');

    var opt = {
      margin:       1,
      filename:     'myfile.pdf',
      image:        { type: 'png', quality: 1.00 },
      html2canvas: {
        dpi: 192,
        scale:4,
        letterRendering: true,
        useCORS: true
      },
      jsPDF:        { unit: 'cm', format: 'A4', orientation: 'portrait' }
    };
     
    // New Promise-based usage:
    await html2pdf(element, opt)
}

window.FillaAttachmentA = FillaAttachmentA

function Timestamp(d,short) {

    let fn = (x) => String(x).length==1?"0"+x:x

    let YYYY = d.getFullYear()
    let MM = fn(d.getMonth()+1)
    let DD = fn(d.getDate())
    let hh = fn(d.getHours())
    let mm = fn(d.getMinutes())
    let ss = fn(d.getSeconds())

    const mesi = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"]

    if (short == true)
        return `${DD}.${MM}.${YYYY}`
    
    return `${DD} ${mesi[d.getMonth()]} ${YYYY}`
}
